import styled from "@emotion/styled";
import { theme } from "../../utils/theme";

const GenerateFormContainer = styled("div")`
  display: grid;
  grid-template-columns: auto 45% auto;
  height: 400px;
  align-items: center;

  form {
    h2 {
      text-align: center;
    }
  }

  @media (max-width: 450px) {
    grid-template-columns: auto 100% auto;
  }

  // Tablets
  @media only screen and (min-width: 768px) {
    grid-template-columns: auto 80% auto;
  }

  // Laptops & Desktops
  @media only screen and (min-width: 992px) {
    display: grid;
    grid-template-columns: auto 45% auto;
    height: 400px;
    align-items: center;

    form {
      h2 {
        text-align: center;
      }
    }
  }
`;

const InputDisabled = styled("input")`
  width: 100%;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 3px #ddd;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
`;

const Wrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  input,
  button {
    width: 100%;
    padding: 0.5rem;
    background-color: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    border-radius: 1rem;
  }
`;

const GenerateMail = ({ text, onClickHandle, onSubmitHandle }) => {
  return (
    <GenerateFormContainer>
      <div></div>
      <form onSubmit={onSubmitHandle}>
        <h2>Your Temporary Email Address</h2>
        <InputDisabled type="text" value={text} disabled />
        <Wrapper>
          <input type="button" value="Generate" onClick={onClickHandle} />
          <button type="submit">Inbox</button>
        </Wrapper>
      </form>
      <div></div>
    </GenerateFormContainer>
  );
};

export default GenerateMail;
